<script>
import axios from 'axios'
export default {
  name: 'videoVimeo',
  props: {
    med: { required: true },
  },
  data () {
    return {
      valvid: '',
      urlvid: '',
    }
  },
  components: {
  },
  methods: {
    getVid: function (url) {
      if (url.includes('youtube')) {
        var link = url.replace(/(<([^>]+)>)/ig, '')
          /* eslint-disable */
        var re = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com|youtu\.be)\/(?:watch\?v=)?([\w\-]{10,12})(?:&feature)?(?:[\w\-]{0})?/g
        var iframe = 'https://www.youtube.com/embed/$1'
          /* eslint-enable */
        link = iframe.replace('$1', link.split(re)[1])
        return link
      } else {
        axios.get('https://vimeo.com/api/oembed.json?url=' + url).then(function (response) {
          var temp = response.data
          this.valvid = temp.html
          return temp.html
        })
      }
    },
    async getHTML (url) {
      var val = ''
      var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
      w = Math.round(w / 2.25)
      // console.log(w / 1.50)
      try {
        var temp = await axios.get('https://vimeo.com/api/oembed.json?url=' + url + '&width=' + w)
      } finally {
        val = temp.data.html
      }
      this.valvid = val
      this.urlvid = val.substring(13, 53)
      return val
    },
    isVimeo: function (url) {
      if (url.includes('vimeo')) {
        this.getHTML(url)
        return true
      } else {
        return false
      }
    },
  },
  mounted () {
  },
}
</script>

<template lang="pug">
.video-vimeo
  div(v-if="isVimeo(med.video.link)")
    div(v-html='valvid')
  div(v-else)
    q-video(:src='getVid(med.video.link)', style='height: 25vw !important')
</template>
<style>
</style>



// WEBPACK FOOTER //
// VideoVimeo.vue?2485f7bb